import InputWithLabel from "app/components/FormInputs/components/InputWithLabel/InputWithLabel";
import { Countries } from "app/types/registrationTypes";
import { registrationInputMaxLength } from "app/utils/const";
import { useEffect, useState } from "react";
import { FormattedMessage, IntlShape } from "react-intl";
//
type Props = {
  handleChange: (id: string, value: string) => void;
  phoneNumberPrefixId: string;
  phoneNumberSuffix: string;
  countries: Countries;
  intl: IntlShape;
  isCanadaSelected: boolean;
  contactNumberValidationError: boolean;
  phoneNumber: string;
};

const ContactNumber = ({
  handleChange,
  phoneNumberPrefixId,
  phoneNumberSuffix,
  countries,
  intl,
  isCanadaSelected,
  contactNumberValidationError,
}: Props) => {
  const [errorPhoneNumberPrefix, setErrorPhoneNumberPrefix] =
    useState<string>("");
  const [errorPhoneNumberSuffix, setErrorPhoneNumberSuffix] =
    useState<string>("");

  // validate the phone number prefix and suffix when user selects canada
  const validateContactNumber = (id: string, value: string) => {
    const newErrors: { [key: string]: string } = {
      [id]: "",
    };

    if (value.length <= 0) {
      newErrors[id] = intl.formatMessage({
        id: "Required",
      });
      id === "phoneNumberPrefix"
        ? setErrorPhoneNumberPrefix(newErrors[id])
        : setErrorPhoneNumberSuffix(newErrors[id]);
    } else {
      newErrors[id] = "";
      id === "phoneNumberPrefix"
        ? setErrorPhoneNumberPrefix(newErrors[id])
        : setErrorPhoneNumberSuffix(newErrors[id]);
    }
  };

  useEffect(() => {
    if (contactNumberValidationError) {
      validateContactNumber("phoneNumberPrefix", "");
      validateContactNumber("phoneNumberSuffix", "");
    } else {
      setErrorPhoneNumberPrefix("");
      setErrorPhoneNumberSuffix("");
    }
  }, [contactNumberValidationError]);

  const handlePhoneNumberChange = (value: string) => {
    handleChange("phoneNumberPrefixId", value);
    // Find the selected country by its ID
    const selectedCountry = countries.find(
      country => country.id.toString() === value
    );
    if (selectedCountry) {
      handleChange("phoneNumberPrefix", selectedCountry["phone-prefix"]);
    } else {
      console.warn(`Country with ID ${value} not found in countries array.`);
    }
  };

  return (
    <div className="form-details__row form-details__single_col">
      <div>
        <FormattedMessage tagName="span" id="home-register-contact-number" />
        &nbsp;
        {isCanadaSelected ? (
          <span className="required">*</span>
        ) : (
          <>
            {" ("}
            <FormattedMessage
              tagName="span"
              id="home-register-contact-optional"
            />
            {`)`}
          </>
        )}
      </div>
      <div className="form-details__col--phone-number">
        <div className="">
          <select
            className={`${errorPhoneNumberPrefix ? "error" : ""}`}
            onChange={e => handlePhoneNumberChange(e.target.value)}
            onBlur={e =>
              validateContactNumber("phoneNumberPrefix", e.target.value)
            }
            id="phoneNumberPrefix"
            value={phoneNumberPrefixId}
          >
            {
              <option value={0}>
                <FormattedMessage id="account-verification-select-document-select-button" />
              </option>
            }
            {countries &&
              countries.map(country => (
                <option
                  key={country.id}
                  value={country.id}
                  data-countrycode={country.code}
                >
                  {country["country-code"]}
                  &nbsp;
                  {"(+"} {country["phone-prefix"]} {")"}
                </option>
              ))}
          </select>
          {errorPhoneNumberPrefix && (
            <span className="error-message">{errorPhoneNumberPrefix}</span>
          )}
        </div>
        <InputWithLabel
          label={intl.formatMessage({
            id: "blank-space",
          })}
          inputId={"phoneNumberSuffix"}
          value={phoneNumberSuffix}
          onValueChange={handleChange}
          key={"phoneNumberSuffix"}
          type={"number"}
          maxLength={registrationInputMaxLength.emailMaxLength}
          placeholder={"000 00 00 000"}
          validateInput={isCanadaSelected}
          error={errorPhoneNumberSuffix}
          handleValidation={validateContactNumber}
          required={false}
        />
      </div>
    </div>
  );
};

export default ContactNumber;
